import type { ESGTranslations } from "../../types/esg";

export const esg: ESGTranslations = {
  title: "ESG Report",
  overview: "Overview",
  metrics: "Detailed ESG Metrics",
  generalDisclosures: "ESRS 2 General Disclosures",
  exportReport: "Export Report",
  exportSuccess: "ESG Report Generated",
  exportSuccessDesc: "Your ESG report has been downloaded successfully.",
  exportError: "Failed to generate ESG report",
  errorTitle: "Error",
  errorLoadingMetrics: "Failed to load ESG metrics",
  errorCreateMetrics: "Failed to create ESG metrics",
  loadError: "Failed to load ESG data",
  saveError: "Failed to save ESG data",
  loading: "Loading ESG data...",
  empty: "No ESG data available",
  buildingNotFound: "Building not found",
  updateSuccessTitle: "Update Successful",
  updateSuccessDesc: "ESG metrics have been updated successfully.",
  updateErrorDesc: "Failed to update ESG metrics",
  detailedMetrics: {
    energyConsumption: "Energy Consumption",
    renewableEnergy: "Renewable Energy",
    waterConsumption: "Water Consumption",
    wasteGenerated: "Waste Generated",
    wasteRecycled: "Waste Recycled",
    ghgEmissions: "GHG Emissions",
    biodiversityArea: "Biodiversity Area",
    accessibilityScore: "Accessibility Score",
    occupantSatisfaction: "Occupant Satisfaction",
    healthSafety: "Health & Safety",
    communityEngagement: "Community Engagement",
    tenantSatisfaction: "Tenant Satisfaction",
    airQuality: "Air Quality",
    governanceStructure: "Governance Structure",
    riskAssessment: "Risk Assessment",
    stakeholderEngagement: "Stakeholder Engagement",
    sustainabilityDueDiligence: "Sustainability Due Diligence",
    boardExpertise: "Board Expertise",
    performanceIntegration: "Performance Integration",
    processEstablished: "Process established and documented",
    committeeEstablished: "Sustainability committee established",
    metricsInIncentives: "ESG metrics in incentive schemes",
    hours: "hours",
    certifications: "Certifications",
    sustainabilityPolicies: "Sustainability Policies",
    esgRiskScore: "ESG Risk Score",
    supplierCodeOfConduct: "Supplier Code of Conduct",
    scope1: "Scope 1",
    scope2: "Scope 2",
    resourceConsumption: "Resource Consumption",
    // Add missing properties
    trainingHours: "Training Hours",
    diversityRatio: "Diversity Ratio",
    workforceManagement: "Workforce Management",
    workerEngagement: "Worker Engagement",
    socialProtection: "Social Protection",
    valueChainManagement: "Value Chain Management",
    workerConditions: "Worker Conditions",
    circularDesign: "Circular Design",
    circularStrategies: "Circular Strategies",
    resourceManagement: "Resource Management",
    conservationTargets: "Conservation Targets",
    restorationPlans: "Restoration Plans",
    biodiversityManagement: "Biodiversity Management",
    marineProtection: "Marine Protection",
    waterStressAreas: "Water Stress Areas",
    marineResources: "Marine Resources",
    waterManagement: "Water Management",
    reachCompliance: "REACH Compliance",
    remediationCases: "Remediation Cases",
    grievanceChannels: "Grievance Channels",
    grievanceCases: "Grievance Cases",
    investment: "Investment",
    engagementEffectiveness: "Engagement Effectiveness",
    consumerProtection: "Consumer Protection",
    productSafety: "Product Safety",
    complaintsResolved: "Complaints Resolved",
    customerSatisfaction: "Customer Satisfaction",
    categories: "Categories",
    costs: "Costs",
  },
  sections: {
    environmental: "Environmental",
    social: "Social",
    governance: "Governance",
  },
  tabs: {
    climate: "Climate Change (E1)",
    pollution: "Pollution (E2)",
    water: "Water & Marine (E3)",
    biodiversity: "Biodiversity (E4)",
    resource: "Resource Use (E5)",
    workforce: "Own Workforce (S1)",
    valueChain: "Value Chain (S2)",
    communities: "Communities (S3)",
    consumers: "Consumers (S4)",
  },
};
